import { useMemo } from 'react';
import { getDeviceId } from '@mentimeter/visitor/visitor-data';
import type { UserT } from '@mentimeter/user';
import type { PresenceUser } from '../types';

interface PresenceUserInput {
  status: PresenceUser['status'];
  actor: PresenceUser['actor'];
  location?: PresenceUser['location'] | undefined;
  user: UserT | null;
}

export const useEditorDefaultPresenceData = ({
  actor,
  location = '/series',
  status,
  user,
}: PresenceUserInput): PresenceUser | null => {
  const { id: user_id, name, email } = user ?? {};
  const profile_picture_url = user?.profile_picture?.presets.preview.url;

  return useMemo(() => {
    if (!user_id) return null;

    return {
      device_id: getDeviceId(),
      last_seen: Date.now(),
      status,
      location,
      actor,
      user_id,
      name: name ?? '',
      email: email ?? '',
      profile_picture_url,
    };
  }, [actor, email, location, name, profile_picture_url, status, user_id]);
};
